import { useSettings } from '../../../Settings/SettingsProvider';
import React, { useState } from 'react';
import {
  useBaseLayerConfigs,
  useActivateBaseMapForm,
} from '../../../Settings/BaseMap';
import {
  Button,
  Command,
  CommandGroup,
  CommandInput,
  CommandItem,
  CommandList,
  Popover,
  PopoverContent,
  PopoverTrigger,
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@ais-ui/ui-core';
import { PiGearThin, PiMapTrifoldThin } from 'react-icons/pi';
import { CheckIcon } from '@radix-ui/react-icons';
import { Link } from 'react-router-dom';
import { ROUTES } from '../../../../routes';
import { S57ConfigPanel } from '../../S57/S57ConfigPanel';

export const BaseMaps = () => {
  const { settings } = useSettings();
  const [open, setOpen] = useState(false);
  const { baseLayerConfigs } = useBaseLayerConfigs();
  const { onSubmit } = useActivateBaseMapForm();
  const onBaseMapSelect = (active_base_map: string) => {
    if (active_base_map) {
      onSubmit({ active_base_map });
    }
    setOpen(false);
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <Tooltip>
        <TooltipTrigger asChild>
          <PopoverTrigger asChild>
            <Button
              id="change-base-map-button"
              size="icon"
              variant="outline"
              className="h-10 w-10 flex-shrink-0 flex-grow-0"
            >
              <PiMapTrifoldThin className="size-5"></PiMapTrifoldThin>
            </Button>
          </PopoverTrigger>
        </TooltipTrigger>
        <TooltipContent>Change base map</TooltipContent>
      </Tooltip>
      <PopoverContent className="p-0">
        <Command>
          <div className="flex items-center justify-between px-3 pt-3 pb-1">
            <h3 className="text-sm font-semibold">Base Maps</h3>
            <Tooltip>
              <TooltipTrigger asChild>
                <Link
                  to={ROUTES.SETTINGS.BASE_MAP.$path()}
                  className="text-foreground/70 hover:text-foreground transition-colors"
                >
                  <PiGearThin className="size-5" />
                </Link>
              </TooltipTrigger>
              <TooltipContent>Manage base maps</TooltipContent>
            </Tooltip>
          </div>
          <CommandInput placeholder="Find base map..." variant="bordered" />
          <CommandList>
            <CommandGroup heading="Select base map">
              {baseLayerConfigs.map((config) => (
                <CommandItem
                  key={config.id}
                  value={config.title}
                  onSelect={() => {
                    onBaseMapSelect(config.id);
                  }}
                >
                  <div className="flex justify-between items-center w-full">
                    <div>{config.title}</div>
                    <div className="flex items-center gap-1">
                      {config.id === 's57' && <S57ConfigPanel />}
                      {settings['ribbonPlugin.settings'].active_base_map ===
                        config.id && <CheckIcon className="size-4" />}
                    </div>
                  </div>
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};
